class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetSubmit = facetForm.querySelector('.submit-filter');
    if (facetSubmit) {
      facetSubmit.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    wrapFunction();
    countingProduct();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    if(document.querySelector('.active-facets.active-facets-desktop').childElementCount > 0) {
      let count = document.querySelectorAll('#grid-collection-scalper .grid__item-collection').length
      // document.querySelector('.submit-filter').innerHTML = 'Ver ' + count + ' productos'
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionS(filterDataUrl, event)
        : FacetFiltersForm.renderSectionF(url, event);
    });

  }

  static renderURL(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event, false);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });

      wrapFunction()
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event, false);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridCount(html) {
    document.getElementById('count_grid_filter').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let count = document.querySelectorAll('#count_grid_filter .grid__item-collection').length
    FacetFiltersForm.updateSubmitFilterLabel(html);
    let product_card = document.querySelectorAll('#count_grid_filter .grid__item-collection .rocket-scalpers-product-card');

    product_card.forEach((item) => {
      item.remove();
    })
    wrapFunction();

    document.querySelector('.rocket-loading-submit').style.display = 'none';
    if(typeof loadMore == 'function') loadMore();

  }

  static updateSubmitFilterLabel(html){
    let button = new DOMParser().parseFromString(html, 'text/html').querySelector('.submit-filter');
    let searchParams = new URLSearchParams(document.location.search);
    document.querySelector('.submit-filter').innerHTML = button.innerHTML
    
    countingProduct();
  }
  static renderSectionF(url, event) {
   fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event, true);
      FacetFiltersForm.renderProductGridCount(html);
      FacetFiltersForm.renderProductCount(html);
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    });

    wrapFunction()
  }

  static renderSectionS(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event, true);
    FacetFiltersForm.renderProductGridCount(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    wrapFunction();
    countingProduct();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('.ProductCount_count').innerHTML;
    const container = document.querySelector('#ProductCount-Mobile .ProductCount_count ');
    const containerDesktop = document.querySelector('#ProductCount-Desktop .ProductCount_count');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event, validate) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
        if(element) {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        }
    });

    if(validate !== true) {
      FacetFiltersForm.renderActiveFacets(parsedHTML, event);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
    }

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const hide = document.getElementById('hide');
    const txt = document.getElementById('CCPriceRangeMin');
    const hideM = document.getElementById('hide');
    const txtM = document.getElementById('CCPriceRangeMax');

    if(hide && txt) {
      hide.textContent = txt.value;
      txt.style.width = hide.offsetWidth + "px";
    }

    if (hideM && txtM) {
      hideM.textContent = txtM.value;
      txtM.style.width = hideM.offsetWidth + "px";
    }

    new PriceRange();
  }

  static renderActiveFacets(html, event) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);

    wrapFunction()
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  combineFormsSeachParams(forms){
    let dataForms = [...forms].map(form => {
      return new FormData(form);
    });
    const result = new URLSearchParams("");
    [...dataForms].map(params => {
      for(var pair of params.entries()) {
        result.append(pair[0], pair[1]);
      }
    });

    return result.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    document.querySelector('.rocket-loading-submit').style.display = 'flex';
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    var searchParams = this.combineFormsSeachParams(sortFilterForms);
    if(document.getElementById('CCPriceRangeMin') && document.getElementById('CCPriceRangeMax')) {
      let value1 = document.getElementById('CCPriceRangeMin').value,
      value2 = document.getElementById('CCPriceRangeMax').value,
      value1min = document.getElementById('CCPriceRangeMin').min,
      value2max = document.getElementById('CCPriceRangeMax').max;
  
      if (value1 === value1min && value2 === value2max) {
        searchParams = searchParams.replace("filter.v.price.gte=" + value1min + "&filter.v.price.lte=" +value2max, "");
      }
    }
    const sections = FacetFiltersForm.getSections();
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      FacetFiltersForm.renderURL(searchParams, event);
      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;
  
        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionS(filterDataUrl, event)
          : FacetFiltersForm.renderSectionF(url, event);
      });

      wrapFunction();
    } else {
        const forms = [];
        const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

        sortFilterForms.forEach((form) => {
            if (!isMobile) {
                if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                    const noJsElements = document.querySelectorAll('.no-js-list');
                    noJsElements.forEach((el) => el.remove());
                    forms.push(this.createSearchParams(form));
                }
            } else if (form.id === 'FacetFiltersFormMobile') {
                forms.push(this.createSearchParams(form));
            }
        });
        let currentActiveType = document.querySelector(".rocket-collection-changeType__product.active") || document.querySelector(".rocket-collection-changeType__model.active");
        currentActiveType?.classList.remove("active");
        this.onSubmitForm(searchParams, event);

        if(event.target.innerHTML === submit_button) {
            document.querySelector('#product-grid').classList.remove('filter-active');
            document.querySelectorAll('.collection-banner').forEach((item) => {
                item.classList.remove('hidden')
            })
        }
        countingProduct()
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let isFilterImage = event.currentTarget.getAttribute("filter-image");
    let url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    if(url === '' && isFilterImage){
      let urlParams = new URLSearchParams(window.location.search);
      let productTypeParams = urlParams.getAll("filter.p.product_type");
      if(productTypeParams.length > 0){
        url = "filter.p.product_type=" + productTypeParams[0];
      }
    }
    FacetFiltersForm.renderPage(url, event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);

class FacetSort extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('.facets__sort-option').forEach((element) => {  
            element.addEventListener('click', this.onSortChange.bind(this));
        });
    }

    onSortChange(event) {
        this.querySelectorAll('.facets__sort-option').forEach((element) => {
            element.classList.remove('selected');
        })
        event.currentTarget.classList.add('selected');
        this.querySelector('select').value = event.currentTarget.dataset.value;
        this.querySelector('select').dispatchEvent(new Event('input', {
            bubbles: true,
            cancelable: true
        }));

        closeFilter();
    }
}
customElements.define('facet-sort', FacetSort);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);


    if(document.querySelector('.filter-price')) {
      let filter_price_max = document.querySelector('#CCPriceRangeMax').getAttribute('max');

      document.querySelector('#CCPriceRangeMin').value = 0;
      document.querySelector('#CCPriceRangeMax').value = filter_price_max;
      document.querySelector('.cc-price-range__control--min').setAttribute("style", "left: 0%");
      document.querySelector('.cc-price-range__control--min').setAttribute("aria-valuenow", 0);
      document.querySelector('.cc-price-range__control--max').setAttribute("style", "left: 100%");
      document.querySelector('.cc-price-range__control--max').setAttribute("aria-valuenow", filter_price_max);
      document.querySelector('.cc-price-range__bar-active').setAttribute("style", "left: 100%, right: 100%");
    }

    if(this.className === 'mobile-facets__clear-wrapper') {
      document.querySelector('.submit-filter').innerHTML = submit_button;
      
      document.querySelector('#product-grid').classList.remove('filter-active');
      document.querySelectorAll('.collection-banner').forEach((item) => {
        item.classList.remove('hidden')
      })
    }

    defaultGridLayout();
    sortProduct();
    countingProduct();
  }
}

customElements.define('facet-remove', FacetRemove);

class ccComponent {
  constructor(name) {var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
    var _this = this;
    this.instances = [];

    // Initialise any instance of this component within a section
    $(document).on('cc:component:load', function (event, component, target) {
      if (component === name) {
        $(target).find("".concat(cssSelector, ":not(.cc-initialized)")).each(function () {
          _this.init(this);
        });
      }
    });

    // Destroy any instance of this component within a section
    $(document).on('cc:component:unload', function (event, component, target) {
      if (component === name) {
        $(target).find(cssSelector).each(function () {
          _this.destroy(this);
        });
      }
    });

    // Initialise any instance of this component
    $(cssSelector).each(function () {
      _this.init(this);
    });
  }

  init(container) {
    $(container).addClass('cc-initialized');
  }

  destroy(container) {
    $(container).removeClass('cc-initialized');
  }

  registerInstance(container, instance) {
    this.instances.push({
      container,
      instance });

  }

  destroyInstance(container) {
    this.instances = this.instances.filter(item => {
      if (item.container === container) {
        if (typeof item.instance.destroy === 'function') {
          item.instance.destroy();
        }

        return item.container !== container;
      }
    });
}}

class PriceRangeInstance {
  constructor(container) {
    this.container = container;
    this.selectors = {
      inputMin: '.cc-price-range__input--min',
      inputMax: '.cc-price-range__input--max',
      control: '.cc-price-range__control',
      controlMin: '.cc-price-range__control--min',
      controlMax: '.cc-price-range__control--max',
      bar: '.cc-price-range__bar',
      activeBar: '.cc-price-range__bar-active' };

    this.controls = {
      min: {
        barControl: container.querySelector(this.selectors.controlMin),
        input: container.querySelector(this.selectors.inputMin) },

      max: {
        barControl: container.querySelector(this.selectors.controlMax),
        input: container.querySelector(this.selectors.inputMax) } };


    this.controls.min.value = parseInt(this.controls.min.input.value === '' ? this.controls.min.input.placeholder : this.controls.min.input.value);
    this.controls.max.value = parseInt(this.controls.max.input.value === '' ? this.controls.max.input.placeholder : this.controls.max.input.value);
    this.valueMin = this.controls.min.input.min;
    this.valueMax = this.controls.min.input.max;
    this.valueMinInt = parseInt(this.valueMin);
    this.valueMaxInt = parseInt(this.valueMax);
    this.valueRange = this.valueMax - this.valueMin;

    [this.controls.min, this.controls.max].forEach(item => {
      item.barControl.setAttribute('aria-valuemin', this.valueMin);
      item.barControl.setAttribute('aria-valuemax', this.valueMax);
      item.barControl.setAttribute('tabindex', 0);
    });
    this.controls.min.barControl.setAttribute('aria-valuenow', this.controls.min.value);
    this.controls.max.barControl.setAttribute('aria-valuenow', this.controls.max.value);

    this.bar = container.querySelector(this.selectors.bar);
    this.activeBar = container.querySelector(this.selectors.activeBar);
    this.inDrag = false;

    this.bindEvents();
    this.render();
  }

  getPxToValueRatio() {
    return this.bar.clientWidth / (this.valueMax - this.valueMin);
  }

  getPcToValueRatio() {
    return 100.0 / (this.valueMax - this.valueMin);
  }

  setActiveControlValue(value) {
    // only accept valid numbers
    if (isNaN(parseInt(value))) return;

    // clamp & default
    if (this.activeControl === this.controls.min) {
      if (value === '') {
        value = this.valueMin;
      }
      value = Math.max(this.valueMin, value);
      value = Math.min(value, this.controls.max.value);
    } else {
      if (value === '') {
        value = this.valueMax;
      }
      value = Math.min(this.valueMax, value);
      value = Math.max(value, this.controls.min.value);
    }

    // round
    this.activeControl.value = Math.round(value);

    // update input
    if (this.activeControl.input.value != this.activeControl.value) {
      if (this.activeControl.value == this.activeControl.input.placeholder) {
        this.activeControl.input.value = '';
      } else {
        this.activeControl.input.value = this.activeControl.value;
      }
      this.activeControl.input.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { sender: 'theme:component:price_range' } }));
    }

    // a11y
    this.activeControl.barControl.setAttribute('aria-valuenow', this.activeControl.value);

    resize();
    resizeM();
  }

  render() {
    this.drawControl(this.controls.min);
    this.drawControl(this.controls.max);
    this.drawActiveBar();
  }

  drawControl(control) {
    control.barControl.style.left = (control.value - this.valueMin) * this.getPcToValueRatio() + '%';
  }

  drawActiveBar() {
    this.activeBar.style.left = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + '%';
    this.activeBar.style.right = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + '%';
  }

  handleControlTouchStart(e) {
    e.preventDefault();
    this.startDrag(e.target, e.touches[0].clientX);
    this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this);
    this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this);
    window.addEventListener('touchmove', this.boundControlTouchMoveEvent);
    window.addEventListener('touchend', this.boundControlTouchEndEvent);
  }

  handleControlTouchMove(e) {
    this.moveDrag(e.touches[0].clientX);
  }

  handleControlTouchEnd(e) {
    e.preventDefault();
    window.removeEventListener('touchmove', this.boundControlTouchMoveEvent);
    window.removeEventListener('touchend', this.boundControlTouchEndEvent);
    this.stopDrag();
  }

  handleControlMouseDown(e) {
    e.preventDefault();
    this.startDrag(e.target, e.clientX);
    this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this);
    this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this);
    window.addEventListener('mousemove', this.boundControlMouseMoveEvent);
    window.addEventListener('mouseup', this.boundControlMouseUpEvent);
  }

  handleControlMouseMove(e) {
    this.moveDrag(e.clientX);
  }

  handleControlMouseUp(e) {
    e.preventDefault();
    window.removeEventListener('mousemove', this.boundControlMouseMoveEvent);
    window.removeEventListener('mouseup', this.boundControlMouseUpEvent);

    this.stopDrag();

    const searchParams = document.querySelector('facet-filters-form.facet-filter-form').createSearchParams(event.target.closest('form'));
    const sections = FacetFiltersForm.getSections();

    FacetFiltersForm.renderURL(searchParams, e);
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      document.querySelector('.rocket-loading-submit').style.display = 'flex';
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        document.getElementById('count_grid_filter').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
        let count = document.querySelectorAll('#count_grid_filter .grid__item-collection').length;
        if(this.valueMinInt === this.controls.min.value && this.valueMaxInt === this.controls.max.value){
          let searchParams = new URLSearchParams(document.location.search).toString();
          searchParams = searchParams.replace("filter.v.price.gte=" + this.controls.min.value + "&filter.v.price.lte=" +this.controls.max.value, "");
          FacetFiltersForm.renderURL(searchParams);
        }
        FacetFiltersForm.updateSubmitFilterLabel(html);
    
        wrapFunction();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        document.querySelector('.rocket-loading-submit').style.display = 'none';
      });
    });
  }

  startDrag(target, startX) {
    if (this.controls.min.barControl === target) {
      this.activeControl = this.controls.min;
    } else {
      this.activeControl = this.controls.max;
    }
    this.dragStartX = startX;
    this.dragStartValue = this.activeControl.value;
    this.inDrag = true;
  }

  moveDrag(moveX) {
    if (this.inDrag) {
      var value = this.dragStartValue + (moveX - this.dragStartX) / this.getPxToValueRatio();
      this.setActiveControlValue(value);
      this.render();
    }
  }

  stopDrag() {
    this.inDrag = false;
  }

  handleControlKeyDown(e) {
    if (e.key === 'ArrowRight') {
      this.incrementControlFromKeypress(e.target, 10.0);
    } else if (e.key === 'ArrowLeft') {
      this.incrementControlFromKeypress(e.target, -10.0);
    }
  }

  incrementControlFromKeypress(control, pxAmount) {
    if (this.controls.min.barControl === control) {
      this.activeControl = this.controls.min;
    } else {
      this.activeControl = this.controls.max;
    }
    this.setActiveControlValue(this.activeControl.value + pxAmount / this.getPxToValueRatio());
    this.render();
  }

  handleInputChange(e) {
    // strip out non numeric values
    e.target.value = e.target.value.replace(/\D/g, '');

    if (!e.detail || e.detail.sender != 'theme:component:price_range') {
      if (this.controls.min.input === e.target) {
        this.activeControl = this.controls.min;
      } else {
        this.activeControl = this.controls.max;
      }
      this.setActiveControlValue(e.target.value);
      this.render();
    }

    resize();
    resizeM();

  }

  handleChangeValue(e) {
    let newEvent = new Event('change'),
        minV = document.querySelector('#CCPriceRangeMin');
        maxV = document.querySelector('#CCPriceRangeMax');

    minV.dispatchEvent(newEvent);
    maxV.dispatchEvent(newEvent);

    resize();
    resizeM();
  }

  handleInputKeyup(e) {
    // enforce numeric chars in the input
    setTimeout(function () {
      this.value = this.value.replace(/\D/g, '');
    }.bind(e.target), 10);
  }

  bindEvents() {
    [this.controls.min, this.controls.max].forEach(item => {
      item.barControl.addEventListener('touchstart', this.handleControlTouchStart.bind(this));
      item.barControl.addEventListener('mousedown', this.handleControlMouseDown.bind(this));
      item.barControl.addEventListener('keydown', this.handleControlKeyDown.bind(this));
      item.barControl.addEventListener('change', this.handleChangeValue.bind(this));
      item.input.addEventListener('change', this.handleInputChange.bind(this));
      item.input.addEventListener('keyup', this.handleInputKeyup.bind(this));
    });
  }

  destroy() {
}}

class PriceRange extends ccComponent {
  constructor() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'price-range';
    var cssSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cc-".concat(name);
    super(name, cssSelector);
  }

  init(container) {
    super.init(container);
    this.registerInstance(container, new PriceRangeInstance(container));

    resize();
    resizeM();
  }

  destroy(container) {
    this.destroyInstance(container);
    super.destroy(container);
  }
}

new PriceRange();
